<template>
  <LayoutOneColumn>
    <div class="flex flex-col gap-4">
      <div
        class="flex gap-2 px-2 overflow-x-scroll max-w-full py-1 md:flex-wrap"
      >
        <SidebarMenuItem
          v-for="section in menu"
          :key="section.id"
          :item="section"
          theme="white"
        />
      </div>
      <NuxtPage />
    </div>
  </LayoutOneColumn>
</template>

<script setup lang="ts">
const { t } = useI18n()
const router = useRouter()
const menu = computed(() => [
  {
    id: 'offer-service',
    local: t(`marketplace.offer_your_service`),
    slug: 'offer-service',
    icon: 'outline_light_bulb',
    route: `/marketplace/offer-service`,
  },
  {
    id: 'marketplace',
    local: t(`marketplace.marketplace`),
    slug: 'marketplace',
    icon: 'outline_shopping_cart',
    route: `/marketplace`,
    isActive: router.currentRoute.value.fullPath.includes(
      '/marketplace/products'
    ),
  },
])
</script>
